import { useLocation } from 'react-router-dom';

const TITLE_MAP = {
  '/admin/dashboard': 'Dashboard',
  '/admin/users': 'Users',
  '/admin/uniform-reports': 'Uniform Reports',
  '/admin/missing-reports': 'Missing Reports',
};

const SUBTITLE_MAP = {
  '/admin/dashboard': 'Overview laporan uniform',
  '/admin/users': 'Kelola data pengguna',
  '/admin/uniform-reports': 'Riwayat laporan seragam',
  '/admin/missing-reports': 'Daftar employee yang belum melapor',
};

const AdminHeader = ({ user, isSidebarOpen, onToggleSidebar }) => {
  const { pathname } = useLocation();
  const basePath = '/' + pathname.split('/').slice(1, 3).join('/');
  const title = TITLE_MAP[basePath] || 'Admin';
  const subtitle = SUBTITLE_MAP[basePath] || null;
  const companyName = user?.company?.name || user?.company_name || (user?.role === 'superadmin' ? 'Semua Company' : '-');

  return (
    <header className="admin-header">
      <div className="admin-header__left">
        <div className="admin-header__title-row">
          <button
            type="button"
            className="admin-header__menu-button"
            onClick={onToggleSidebar}
            aria-label={isSidebarOpen ? 'Tutup menu navigasi' : 'Buka menu navigasi'}
            aria-expanded={isSidebarOpen}
          >
            <span aria-hidden="true">{isSidebarOpen ? 'x' : '|||'}</span>
          </button>
          <h1 className="admin-header__title">{title}</h1>
        </div>
        {subtitle && <p className="admin-header__subtitle">{subtitle}</p>}
      </div>
      <div className="admin-header__user">
        <div className="admin-header__avatar">{user?.name?.charAt(0) || 'A'}</div>
        <div className="admin-header__user-info">
          <div className="admin-header__user-name">{user?.name}</div>
          <div className="admin-header__user-company">{companyName}</div>
          <div className="admin-header__user-role">{user?.role}</div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
